














import { monsidoUtilities, TrackingTexts } from "@/lib/utilities/monsidoUtilities";
import Vue from "vue";
import SkiModal from "./SkiModal.vue";

export default Vue.extend({
  components: { SkiModal },
  props: {
    agreementId: { type: String, required: false },
    show: { type: Boolean, default: false },
  },
  methods: {
    login(): void {
      monsidoUtilities.trackEvent(
        TrackingTexts.LogInEventCategory,
        "Klik på Gå til Log ind i modal",
        this.agreementId !== null
          ? `Log ind via modal for statusopdateringer for aftale: ${this.agreementId}`
          : "Log ind via modal"
      );
      this.$store.dispatch("signIn", window.location.href);
    },
  },
});
